import * as Sentry from '@sentry/react'

export function initSentry() {
  const dsn = import.meta.env.VITE_SENTRY_DSN
  
  if (!dsn) {
    console.warn('Sentry DSN not configured. Skipping initialization.')
    return
  }

  Sentry.init({
    dsn,
    environment: import.meta.env.MODE,
    sendDefaultPii: true, // IP address等のデフォルトPII送信
    integrations: [
      Sentry.browserTracingIntegration(),
      Sentry.replayIntegration({
        maskAllText: false,
        blockAllMedia: false,
      }),
    ],
    // Performance Monitoring
    tracesSampleRate: 0.1, // 10%のトレースをキャプチャ
    // Session Replay
    replaysSessionSampleRate: 0.1, // 通常セッションの10%
    replaysOnErrorSampleRate: 1.0, // エラー発生時は100%
  })
}
